import { render, staticRenderFns } from "./SearchInput2.vue?vue&type=template&id=a3dfac36"
import script from "./SearchInput2.vue?vue&type=script&lang=js"
export * from "./SearchInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports